<script setup>
const props = defineProps({
  text: String,
})
</script>

<template>
  <div class="equal-base equal-base--tighter-bold item">
    {{ props.text }}
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.item {
  width: 100%;
  padding: 14px 20px;
  margin: auto;
  text-align: center;

  &--large {
    padding: 30px 40px;

    @include media-breakpoint-down(640) {
      padding: 20px 25px;
    }
  }
}
</style>
